module.exports = __webpack_public_path__ + "img/daytime_study2_sm.4572a7f1.png";